'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras) {
  this.vL = null;
  this.vM = null;
  this.vO = null;
  this.vN = null;
  this.vJ = null;
  this.vK = null;
  this.vL = months;
  this.vM = shortMonths;
  this.vO = weekdays;
  this.vN = shortWeekdays;
  this.vJ = amPm;
  this.vK = eras;
}
export { $c_Llocales_cldr_CalendarSymbols as $c_Llocales_cldr_CalendarSymbols };
$p = $c_Llocales_cldr_CalendarSymbols.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $h_Llocales_cldr_CalendarSymbols() {
}
export { $h_Llocales_cldr_CalendarSymbols as $h_Llocales_cldr_CalendarSymbols };
$h_Llocales_cldr_CalendarSymbols.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarSymbols)) {
    var x = this.vL;
    var x$2 = x$0.vL;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.vM;
      var x$4 = x$0.vM;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.vO;
      var x$6 = x$0.vO;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.vN;
      var x$8 = x$0.vN;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.vJ;
      var x$10 = x$0.vJ;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.vK;
      var x$12 = x$0.vK;
      return ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 6;
});
$p.o = (function() {
  return "CalendarSymbols";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.vL;
      break;
    }
    case 1: {
      return this.vM;
      break;
    }
    case 2: {
      return this.vO;
      break;
    }
    case 3: {
      return this.vN;
      break;
    }
    case 4: {
      return this.vJ;
      break;
    }
    case 5: {
      return this.vK;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dY)));
}
export { $isArrayOf_Llocales_cldr_CalendarSymbols as $isArrayOf_Llocales_cldr_CalendarSymbols };
var $d_Llocales_cldr_CalendarSymbols = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_CalendarSymbols, "locales.cldr.CalendarSymbols", ({
  dY: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_CalendarSymbols as $d_Llocales_cldr_CalendarSymbols };
